import React, { Component } from "react";
import './App.css';

import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Activities from "./pages/Activities"
import Brothers from "./pages/Brothers"
import Home from "./pages/Home"
import Join from "./pages/Join"
import Rush from "./pages/Rush"
import { Route, Routes } from "react-router-dom"


class App extends Component {

  // constructor(props) {
  //   super(props);
  //   this.state = { apiResponse: "" };
  // }

  // callAPI() {
  //   fetch("http://localhost:9000/testAPI")
  //     .then(res => res.text())
  //     .then(res => this.setState({ apiResponse: res }));
  // }

  // componentWillMount() {
  //   this.callAPI();
  // }

  render() {
    return (
      <>
      <Navbar />
      <body>
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<Activities />} />
          <Route path="/Brothers" element={<Brothers />} />
          <Route path="/Join" element={<Join />} />
          <Route path="/Rush" element={<Rush />} />
        </Routes>
      </div>
      <div className="footer">
        <Footer />
      </div>
      </body>
      {/* <div className="App">
        <p className="App-intro">{this.state.apiResponse}</p>
      </div> */}
      </>
    );
  }
}

export default App;
